import { useEffect, memo } from "react";
//import "rc-slider/assets/index.css";
import { PlusIcon, MinusIcon } from "@heroicons/react/24/outline";
import PresetList from "./preset-list";
import PtzController from "./ptz-svg";
import PubSub from "pubsub-js";
const PtzControl = ({
  camera,
  maxHeight,
  hidePresetList,
  style,
  width = "100px",
  bottomHeight = "30%",
}: {
  camera: any;
  maxHeight?: number;
  hidePresetList?: boolean;
  style?: any;
  width?: string;
  bottomHeight?: string;
}) => {
  //const [loading, setLoading] = useState(false);

  if (!camera) {
    return <div className="">Loading...</div>;
  }
  if (!camera?.capabilities?.ptz) {
    return <div className="">Not supported</div>;
  }

  function ptz(cmd: string) {
    console.log("ptz", cmd);
    PubSub.publish("focusPtzControl", { cmd, cameraId: camera?.id });
  }
  function takeSnapshots() {
    console.log("takeSnapshots");
    PubSub.publish("focusPtzControlSnapshot", { cameraId: camera?.id });
  }
  return (
    <div className="overflow-y-auto" style={{ maxHeight: maxHeight, ...style }}>
      <div
        className="overflow-y-auto flex gap-4 justify-around items-center h-full w-full"
        style={{ maxHeight: "inherit" }}
      >
        <div
          className="pl-2 py-2 3xl:py-4 ml-8 h-full flex justify-center flex-col flex-grow gap-2"
          style={{ width }}
        >
          <PtzController
            funcPtz={(cmd) => ptz(cmd)}
            funcSnapshot={() => takeSnapshots()}
          />

          <div
            className=" flex gap-4 items-center justify-center"
            style={{ height: bottomHeight }}
          >
            <button
              onMouseDown={() => ptz("ZoomOut")}
              onMouseUp={() => ptz("Stop")}
              onMouseLeave={() => ptz("Stop")}
              className=" h-full rounded-full flex items-center justify-center border border-neutral-200 hover:bg-neutral-200 aspect-square"
            >
              <MinusIcon className="w-5 text-neutral-800" />
            </button>
            <button
              onMouseDown={() => ptz("ZoomIn")}
              onMouseUp={() => ptz("Stop")}
              onMouseLeave={() => ptz("Stop")}
              className=" h-full rounded-full flex items-center justify-center  border border-neutral-200 hover:bg-neutral-200 aspect-square"
            >
              <PlusIcon className="w-5 text-neutral-800" />
            </button>
          </div>
        </div>
        <div
          className="pr-2 h-full flex-shrink-0 relative flex  justify-center flex-col"
          style={{ flexGrow: 2, maxWidth: "65%" }}
        >
          {!hidePresetList && (
            <PresetList
              selectedCamera={{
                cameraMac: camera?.macAddress,
                nvrId: camera?.nvrId,
                cameraId: camera?.id,
                remoteIndex: camera?.remoteIndex,
                orgId: camera?.orgId,
                devId: camera?.devId,
              }}
              fixedSize={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(PtzControl);
